import { render, staticRenderFns } from "./WorkspaceExpandBatchesContent.vue?vue&type=template&id=5773a1c6&scoped=true"
import script from "./WorkspaceExpandBatchesContent.vue?vue&type=script&lang=js"
export * from "./WorkspaceExpandBatchesContent.vue?vue&type=script&lang=js"
import style0 from "./WorkspaceExpandBatchesContent.vue?vue&type=style&index=0&id=5773a1c6&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5773a1c6",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/ec2-user/.jenkins/workspace/CFDE Knowledge - Dev/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5773a1c6')) {
      api.createRecord('5773a1c6', component.options)
    } else {
      api.reload('5773a1c6', component.options)
    }
    module.hot.accept("./WorkspaceExpandBatchesContent.vue?vue&type=template&id=5773a1c6&scoped=true", function () {
      api.rerender('5773a1c6', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/researchPortal/customComponents/revealKgWorkspace/WorkspaceExpandBatchesContent.vue"
export default component.exports